import React from "react";
import { useMTReportProductColumns } from "./useMTReportProductColumns";
import { AccessRights } from "../../../core/navigation/types";
import { TradeList } from "../../../data/trading/trades/types";
import { Table, TableDataProps } from "../../components/common/Table";
import { MonthlyTradingReportData } from "../../../data/reports/monthlyTrade/types";
import { useReportProductData } from "../../../data/reports/monthlyTrade/hooks/useReportProductData";
import { useMonthlyActions } from "./useMonthlyActions";

export interface MonthlyTradesTableProps {
  userAccessRights: AccessRights;
}

type MonthlyTradesTablePropsType = MonthlyTradesTableProps &
  TableDataProps<TradeList>;

const MTRProductTable: React.FunctionComponent<MonthlyTradesTablePropsType> = ({
  userAccessRights,
  ...tableProps
}) => {
  const columns = useMTReportProductColumns();
  const [data, load, reset] = useReportProductData();
  React.useEffect(() => reset, [reset]);

  return (
    <Table<MonthlyTradingReportData>
      {...tableProps}
      getData={load}
      immutableData={data}
      title=""
      columns={columns}
      //      actions={actions}
      options={{
        actionsColumnIndex: -1,
        search: false,
        toolbar: false,
      }}
    />
  );
};

export default MTRProductTable;
